import React from "react";
import MenuNavbar from '../function-components/MenuNavbar'
import Floaticons from '../function-components/Floaticons'
import "./EcoSystemPartners.css"

function EcoSystem() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />

            <div className="Eco-cont">
                <h2 className="Eco_head">
                    Eco System Partners
                </h2>
                <p className="Eco-content">
                    An Ecosystem Partner is a company Accenture officially creates a strategic alliance with including financial arrangements to better serve our clients along with negotiated training benefits. Click on the Ecosystem Partner to enter an official Accenture site, be taken directly to myLearning, or to our Partner site if the proper agreement is in place.
                    <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Ecosystem"
                        target="_blank" >
                        Know More
                    </a>
                </p>
            </div>
        </>
    );
}

export default EcoSystem;
